const t=[{opacity:0,transform:"translateY(-15rem)"},{opacity:1,transform:"translateY(0)"}];export{t as fadeAndSlideInKeyframes};
